import QS from 'qs'
import NoSleep from 'nosleep.js'
import { get as _get, cloneDeep } from 'lodash'
import {calcComparev3Insurance, getComparev3Insurance, initComparev3InterestData,saveComparev3Plan,getComparev3InterestDetailWithTiers} from '@/pages/planbkTemplatev2/js/api.js'
import { addPbCount, completeMission, resultShare, wxClientSaveOperate } from 'api/index'
import Oauth from '@/base/oauth.js'
import Share from '@/base/model/share.js'
import Wechat from '@/base/wechat.js'
import { AP_ASHEET, icons } from '@/pages/planbkTemplate/base/config'
import { IS_PRODUCT_ENV, isApp, APP_CHANNEL, URL_PARAM, isBaoXiaoZhuSingle } from 'common/utils/variables'
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
import { isBxs, inWechat, isYjjApp, isToBApp, isWeCom, isMiniBankInsurance, APPID, wxMpAppid, componentAppid, POLICY_WECHAT_SHARED_LOGO, POLICY_SHARE_DECS, SHARE_DECS, isNuoYa } from '@/base/config.js'
import { showRightIcon } from '@/common/bridge'
import {createDefaultCompareCase,createPersonData} from '@/pages/planbkTemplatev2/components/footerBar/constant'

const { shareFrom } = URL_PARAM
export async function initNativeShare (options = {}) {
  const { uuid } = URL_PARAM
  const { $refs, isMiniprogram, isPolicyCheck, isSupportRecordScreen, isForPresentation, showType, title, tmpData, getThemeSettings, getAppParams, callback } = options
  const { card, insuranceType, resultData } = tmpData
  const cardUuid = URL_PARAM.cardUuid || (card && card.uuid) || (card && card.userUuid) || ''
  const name = card && card.name
  const img = isPolicyCheck ? POLICY_WECHAT_SHARED_LOGO : (insuranceType ? insuranceType.wechatSharedLogoUrl : '')
  const insuranceTypeId = resultData.insuranceTypeId

  const themeSettings = (typeof getThemeSettings === 'function') && getThemeSettings() || {}
  const urlParams = {
    ...URL_PARAM,
    theme: themeSettings.previewTheme,
    cardUuid,
    inGroup: true,
    dfSort: showType,
    appId: APPID,
    shareFrom: shareFrom || APP_CHANNEL,
  }
  if(isBaoXiaoZhuSingle) {
    urlParams.bxzSingle = 1
  }
  const shareLink = `${location.origin + location.pathname}?${QS.stringify(urlParams)}`
  const baseConfig = {
    desc: `${name}${isPolicyCheck ? POLICY_SHARE_DECS : SHARE_DECS}`,
    bizChannel: 'jhs',
    taskId: 'share_planbook',
    title,
    link: shareLink,
    img
  }

  // wxwork
  if (isWeCom && window.WeCom && WeCom.initWeComConfig) {
    const appParams = await getAppParams()
    WeCom.initWeComConfig({
      title: baseConfig.title,
      desc: baseConfig.desc,
      imgUrl: baseConfig.img,
      link: `${location.origin + location.pathname}?${QS.stringify({
        ...urlParams,
        ...appParams,
        theme: themeSettings.previewTheme,
        nocard: 1 // 隐藏名片
      })}`,
      success: () => {
        resultShare({ uuid })
      }
    }, true)
    return
  }

  // 小程序
  if (isMiniprogram) {
    const miniShareURL = `${location.origin + location.pathname}?${QS.stringify({
      ...urlParams,
      theme: themeSettings.previewTheme,
      nobar:  1 // 隐藏功能栏
    })}`
    // 银保小程序
    if (isMiniBankInsurance && WeCom.initMiniConfig) {
      WeCom.initMiniConfig({
        title: baseConfig.title,
        desc: baseConfig.desc,
        imgUrl: baseConfig.img,
        link: miniShareURL
      })
    } else {
      wx.miniProgram.postMessage({
        data: {
          shareConfig: {
            title: baseConfig.title,
            imageUrl: '', // baseConfig.img，图片尺寸问题不使用，使用页面截图
            shareUrl: miniShareURL
          }
        }
      })
    }
    return
  }

  let asConfig = null
  const lazyDataCb = async config => {
    let params = {
      ...urlParams
    }
    if (['wechat_timeline', 'wechat_friends'].includes(config.action)) {
      const lazyThemeSettings = (typeof getThemeSettings === 'function') && getThemeSettings() || {}
      const appParams = await getAppParams()
      params = {
        ...params,
        ...appParams,
        theme: lazyThemeSettings.previewTheme
      }
    }

    if ($refs.InterestDemoV2) {
      const newResultUuid = await $refs.InterestDemoV2.save()
      params.uuid = newResultUuid || params.uuid
    }
    addPbCount({ uuid, type: 'pb_share'})
    completeMission({ SourceId: uuid, missionCode: 'share_planbook' })
    resultShare({ uuid })
    window.WeiyiStatSDK.submit('share')
    const _config = new Share({
      ...config,
      link: `${location.origin + location.pathname}?${QS.stringify(params)}`
    })

    console.log(_config.shareUrl)
    return _config
  }

  if ((isApp && appBridge && appBridge.checkAppFeature(AP_ASHEET)) || isNuoYa) {
    const shareChannels = ['wechat_friends']
    if (appBridge.isIos() || appBridge.isAndroid()) {
      shareChannels.push('system_share')
    }
    shareChannels.push('wechat_timeline')
    // bxs：加入小程序和钉钉
    if (isBxs) {
      shareChannels.push('miniProgramData')
      shareChannels.push('ding_talk')
    }

    const shareGroup = shareChannels.map(channel => {
      if (channel === 'miniProgramData') {
        return {
          action: channel,
          webPageUrl: 'http://www.winbaoxian.com/',
          userName: 'gh_db166d39960f',
          path: `/pages/result/index?uuid=${uuid}&theme=${themeSettings.previewTheme}&t=1`,
          title: '买保险优选服务',
          description: `${IS_PRODUCT_ENV ? '' : '(测试版)'}${title}，${name}为您定制`,
          imageUrl:
            'http://img.winbaoxian.com/autoUpload/planbook/__87080b709204b35.png',
          miniProgramType: IS_PRODUCT_ENV ? 0 : 2
        }
      }
      const config = {
        ...baseConfig,
        action: channel
      }
      return new Share({
        ...config,
        cb: lazyDataCb.bind(null, config)
      })
    })

    const actionGroup = [
      { action: 'text_zoom' }
    ]
    if (isBxs || isToBApp) {
      actionGroup.push({
        action: {
          action: 'custom_feedback',
          title: '反馈',
          icon: icons.feedback
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          location.href = `${PLANBOOK_PAGE_MAP.pdfViewer}?nw=1&type=8&planbookId=${insuranceTypeId}`
        }
      })
    }
    if (isBxs || isYjjApp) {
      actionGroup.push({
        action: {
          action: 'invitation',
          title: '同屏讲解',
          icon: icons.invitation
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          callback && callback({
            isPreInvitationShow: true
          })
        }
      })
    }
    if ((isBxs || isToBApp || isNuoYa) && isSupportRecordScreen) {
      actionGroup.push({
        action: {
          action: 'record_screen',
          title: '录制视频',
          icon: icons.recordScreen
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          callback && callback({
            recordScreenShow: true
          })
        }
      })
    }

    asConfig = {
      title: '',
      channel: 'jhs',
      shareGroup,
      actionGroup,
      expire: {
        options: appBridge.PRESET_ACTIONSHEET_SHARE_EXPIRE_PERIODS,
        urlAfterExpire: shareGroup[0].shareUrl + `&wy_expire=${new Date().getTime()}`
      }
    }

    // // 调试
    // shareGroup.forEach(ele => {
    //   ele.lazyDataCb && ele.lazyDataCb()
    // })
    // actionGroup.forEach(ele => {
    //   if (ele.action && ele.action.action === 'custom_feedback') {
    //     return
    //   }
    //   ele.customActionHandler && ele.customActionHandler()
    // })
    // console.error('调试用，上线请删除')


      // nuoya
    if (isNuoYa) {
      let wxConfig = asConfig.shareGroup.find(item => item.action === 'wechat_friends')
      const { title, content, imgUrl, shareUrl } = wxConfig;

      const shareConfig = { title, content, imgUrl, shareUrl }
      showRightIcon(shareConfig)
    } else {
      appBridge.commonActionSheet(asConfig)
      if (appBridge && appBridge.checkAppFeature('ON_APP_BACK_TO_INPUT_PAGE')) {
        appBridge.onAppBackToInputPage(() => {
          appBridge.commonActionSheet(asConfig)
          $refs.recordScreen.getRecordScreenStatus()
        })
      }
    }
  }
  callback && callback({
    shareLink,
    asConfig
  })
}

export async function initWechatShare (options = {}) {
  const { token, title, tmpData, appPlatform, isMiniprogram, isPolicyCheck, isReplay, fromWyjhs, showType, callback } = options

  const operateParams = {
    token,
    title,
    showType,
    tmpData,
    appPlatform,
    isMiniprogram,
    isPolicyCheck
  }

  // 银保小程序：非微信授权，在小程序内保存用户行为
  if (isMiniprogram && isMiniBankInsurance && WeCom.initMiniConfig) {
    saveOperate(operateParams)
    return
  }

  // 授权：微信下，且非小程序、非同屏讲解回放（isReplay）、非企业微信（isWeCom）、!fromWyjhs
  if (!inWechat || isMiniprogram || isReplay || isWeCom || fromWyjhs) {
    return
  }

  // 微信授权并保存用户行为记录
  let isAuthed = null
  if (!['WECHAT_GAOKE', 'WECHAT_GAOKE_CUSTOMER'].includes(APP_CHANNEL)) {
    isAuthed = await Oauth({
      token,
      wxMpAppid,
      componentAppid
    }).catch(() => {})
  }
  saveOperate({
    ...operateParams,
    isAuthed
  }).then(res => {
    if (res && callback) {
      callback && callback({
        clientUuid: res.clientUuid,
        insuranceTypeId: res.insuranceTypeId,
        heartSec: res.heartSec
      })
    }
  })
}

// 保存行为记录
export async function saveOperate (options = {}) {
  const { uuid, pathUuid } = URL_PARAM
  const {
    token,
    title,
    showType,
    tmpData,
    isMiniprogram,
    isPolicyCheck,
    isAuthed,
    appPlatform
  } = options

  const { card, insuranceType, resultData, heartSec } = tmpData
  const cardUuid = URL_PARAM.cardUuid || (card && card.uuid) || ''
  const userStrId = URL_PARAM.userUuid || (card && card.userUuid) || ''
  const name = card && card.name ? card.name : ''
  const TobAPPID = URL_PARAM.appId || (card && card.tobAppId) || APPID
  const img = isPolicyCheck ? POLICY_WECHAT_SHARED_LOGO : (insuranceType ? insuranceType.wechatSharedLogoUrl : '')
  const oauthExtendMsg = insuranceType ? insuranceType.name : null
  const insuranceTypeId = resultData.insuranceTypeId

  const baseParams = {
    userStrId, // 代理人标识
    source: 4,
    operate: appBridge && appBridge.isCurrentSharedPageExpired && appBridge.isCurrentSharedPageExpired() ? 'view2' : 'view',
    linkId: uuid,
    businessId: insuranceTypeId, // 获客行为产品ID
    dynamicMsg: [oauthExtendMsg], // 获客行为动态文案
    previousOperateUuid: pathUuid, // 上一个分享人的行为UUID，当前接口返回
    jumpUrl: `${location.origin}${location.pathname}?nw=1&uuid=${uuid}&cardUuid=${cardUuid}`,
    humanPathFlag: true
  }

  // 银保小程序行为轨迹
  if (isMiniprogram && isMiniBankInsurance && WeCom.initMiniConfig) {
    WeCom.initMiniConfig({
      ...baseParams,
      // 银保小程序特有
      // 指定分享链接上承载 previousOperateUuid 的 key
      pathUuid: 'pathUuid'
    })
    return
  }

  const urlParams = {
    ...URL_PARAM,
    sharePlatform: appPlatform,
    dfSort: showType,
    autoOauth: undefined,
    fromWyjhs: undefined
  }

  if (['WECHAT_GAOKE'].includes(APP_CHANNEL)) {
    urlParams.jumpSource = 'WECHAT_GAOKE_CUSTOMER'
  }

  const wxConfig = {
    action: 'wechat',
    link: `${location.origin + location.pathname}?${QS.stringify(urlParams)}`,
    desc: `${name}${SHARE_DECS}`,
    title,
    img,
    success: function () {
      window.WeiyiStatSDK.submit('share')
    }
  }
  if (isAuthed) {
    try {
      const { data, info } = await wxClientSaveOperate({
        appId: wxMpAppid, // 微信授权APP_ID
        token,
        userAppId: TobAPPID, // 保险师 独代 企微
        ...baseParams
      })
      console.warn('[Operate]', info)
      urlParams.pathUuid = data.operateUuid
      urlParams.token = undefined
      wxConfig.link = `${location.origin + location.pathname}?${QS.stringify(urlParams)}`
      Wechat(new Share(wxConfig), location.href, wxMpAppid)
      return {
        ...data,
        insuranceTypeId,
        heartSec
      }
    } catch (err) {
      Wechat(new Share(wxConfig), location.href, wxMpAppid)
      console.warn('[Operate]', err)
      return new Error(err)
    }
  } else {
    Wechat(new Share(wxConfig), location.href, wxMpAppid)
  }
}

const noSleep = new NoSleep();
export function enableNoSleep () {
  if (
    window.appBridge &&
    appBridge.isApp() &&
    appBridge.checkAppFeature('SET_KEEP_SCREEN_ON')
  ) {
    appBridge.setKeepScreenOn({ isOn: true })
    return
  }
  document.addEventListener('click', function _enableNoSleep() {
    document.removeEventListener('click', _enableNoSleep, false);
    noSleep.enable();
  }, false);
}

export function disableNoSleep () {
  if (
    window.appBridge &&
    appBridge.isApp() &&
    appBridge.checkAppFeature('SET_KEEP_SCREEN_ON')
  ) {
    appBridge.setKeepScreenOn({ isOn: false })
    return
  }
  noSleep.disable();
}

export function showTopArrow() {
  var box = document.createElement('div')
  box.innerHTML = `<div style='position: fixed;width: 100%;height: 100%;left: 0;top: 0;background: rgba(0, 0, 0, 0.5); z-index: 100000'>
    <img src='//res.winbaoxian.com/static/qw/tip.png' style='width: 60%;display: block;margin: 5px 0 0 36%'>
  </div>`
  document.body.appendChild(box)
  box.onclick = function() {
    document.body.removeChild(box)
  }
}

export function calcCompareInsurance (data) {
  const { resultSource, personList, insuranceList } = data
  const _insuranceList = insuranceList.filter(e => !e.isGroup)
  const resultData = getCleanResultData(getResultDataFromInsureData({
    personList,
    insuranceList: _insuranceList
  }))
  return calcComparev3Insurance({
    resultSource,
    personList: resultData.personList,
    insuranceList: resultData.insuranceList,
  })
    .then(data => {
      const _insuranceList = resultData.insuranceList || []
      _insuranceList.forEach(ins => {
        const _ins = (data.data.data || []).find(d => d.key === ins.key && d.title)
        if (_ins) {
          for (const k in _ins) {
            if (_ins[k] !== null) {
              ins[k] = _ins[k]
            }
          }
        } else {
          ins.title = false
        }
      })
      return _insuranceList.filter(ins => ins.title)
    })
}

export function getCleanResultData (resultData) {
  const newResultData = cloneDeep(resultData)
  if (newResultData) {
    const { insuranceList } = newResultData
    if (Array.isArray(insuranceList)) {
      insuranceList.forEach(item => {
        const noNeedKeys = [
          'allowSamePerson',
          'calculatorType',
          'canRenewFlag',
          'feeBase',
          'feeBaseType',
          'feeType',
          'isCheckbox',
          'isFollowing',
          'required',
          'roundingMode',
          'scale'
        ]
        noNeedKeys.forEach(k => {
          if (k in item) {
            delete item[k]
          }
        })
      })
    }
  }
  return newResultData
}
export function getResultDataFromInsureData (insureData) {
  const resultData = {
    personList: [],
    insuranceList: [],
  }
  const _cpInsureData = cloneDeep(insureData)
  if (_cpInsureData) {
    const _keys = ['personList', 'insuranceList']
    _keys.forEach(_key => {
      const _list = _cpInsureData[_key] || []
      _list.forEach(_item => {
        if (_key === 'personList') {
          _item.title = true
        }
        const _elementList = _item.elementList || _item.eleOrderList || []
        _elementList.forEach(e => {
          _item[e.key] = e.value
        })
        delete _item.elementList
        delete _item.eleOrderList
      })
      resultData[_key] = _list
    })
  }
  return resultData
}

export function getCompareCaseByInsuranceId (insuranceId) {
  const promises = []
  promises.push(getComparev3Insurance({ insuranceId }))
  promises.push(initComparev3InterestData({ insuranceId }))
  return Promise.all(promises).then(async ([insuranceResponse, interestResponse]) => {
    const insurance=insuranceResponse.data.data
    const interest=interestResponse.data.data
    const compareCase = initCompareDataFromInsureData(insurance)
    if (compareCase.insureData) {
      const { personList, insuranceList, verifyData } = compareCase.insureData
      if (Array.isArray(insuranceList)) {
        insuranceList.forEach(e => {
          if (e.eleOrderList) {
            // 除有 num 元素的险种，其他的默认都加保额保费互算。From Hanxinwei
            const hasNumEle = e.eleOrderList.some(ele => ele.key === 'num')
            if (!hasNumEle) {
              const _hasCalMethodEle = e.eleOrderList.some(ele => ele.key === 'calMethod')
              const _hasBaoeEle = e.eleOrderList.some(ele => ele.key === 'baoe')
              e.eleOrderList = e.eleOrderList.filter(ele => ele.key !== 'calMethod')
              const _baoeOrBaofIndex = e.eleOrderList.findIndex(ele => ['baoe', 'baof'].includes(ele.key))
              // 兼容老数据：
              // - 对于原配置中没有测算模式的险种，已保存的结果页数据中， calMethod 是 null，这种情况下不能默认为 baof2baoe
              // - 只能根据配置项来反推默认值。比如：只有保额项，那肯定是 baoe2baof
              const _eleMap = {
                calMethod: {
                  key: 'calMethod',
                  value: !_hasCalMethodEle && _hasBaoeEle ? 'baoe2baof' : 'baof2baoe',
                  componentName: 'cmCommonRadioBtn',
                  labelName: '测算模式',
                  opts: [
                    { val: 'baof2baoe', desc: '保费算保额' },
                    { val: 'baoe2baof', desc: '保额算保费' },
                  ]
                },
                baoe: {
                  key: 'baoe',
                  value: null,
                  componentName: 'cmCommonInput',
                  labelName: '保额'
                },
                baof: {
                  key: 'baof',
                  value: null,
                  componentName: 'cmCommonInput',
                  labelName: '保费'
                }
              }
              Object.keys(_eleMap)
                .filter(k => !e.eleOrderList.find(ele => ele.key === k))
                .forEach(k => {
                  if (k === 'calMethod') {
                    e.eleOrderList.splice(_baoeOrBaofIndex, 0, _eleMap[k])
                  } else {
                    e.eleOrderList.push(_eleMap[k])
                  }
                })
            }
          }
        })
      }
      if (interest) {
        interest.accRate = Number((interest.accRate / 100).toFixed(4))
      }
      compareCase.insureData.interestSetting = interest
    }
    return compareCase
  }).catch(()=>{
    console.log(err);
  })
}

export function initCompareDataFromInsureData (data) {
  const _compareCase = createDefaultCompareCase()
  if (data) {
    const _personItem = createPersonData('insuredInfo')
    const _insuranceId = data.insuranceId
    const _insuranceVerifyData = data.verifyData && data.verifyData[_insuranceId]
    if (Array.isArray(_insuranceVerifyData)) {
      const sexOptions = []
      const ageOptionMap = {
        gender1: [],
        gender2: [],
      }
      _insuranceVerifyData.forEach(item => {
        if (!sexOptions.some(o => o.value === item.sex)) {
          sexOptions.push({ value: item.sex, name: ['男', '女'][item.sex - 1]})
        }
        for (let age = item.minAge; age <= item.maxAge; age ++) {
          const _options = ageOptionMap[`gender${item.sex}`]
          if (!_options.some(o => o.value === age)) {
            _options.push({ value: age, name: `${age}岁` })
          }
        }
      })
      _personItem.elementList.forEach(ele => {
        if (ele.key === 'sex') {
          ele.options = sexOptions
        }
        if (ele.key === 'age') {
          ele.options = ageOptionMap.gender1
          if (!ageOptionMap.gender2.every(o2 => ageOptionMap.gender1.some(o => o.value === o2.value))) {
            ele.optionMap = ageOptionMap
          }
        }
      })
    }
    const _insuranceData = data.initData
    if (_insuranceData && Array.isArray(_insuranceData.eleOrderList)) {
      _insuranceData.eleOrderList.forEach(ele => {
        if (ele.componentName === 'cmCommonSelect') {
          const _options = ele.options || ele.opts
          if (Array.isArray(_options) && _options.length <= 4) {
            ele.componentName = 'cmCommonRadio'
          }
        }
      })
    }
    _compareCase.insureData = {
      companyId: data.companyId,
      personList: [_personItem],
      insuranceList: [_insuranceData],
      verifyData: data.verifyData,
    }
  }
  return _compareCase
}

export function saveComparePlan (data) {
  const { resultSource, planUuid, interestSetting } = data
  const resultData = getCleanResultData(getResultDataFromInsureData(data))
  return saveComparev3Plan({
    resultSource,
    resultUuid: planUuid,
    personList: resultData.personList,
    insuranceList: resultData.insuranceList,
    interestSetting
  })
}

export function getCompareInterestDetailWithTiers (resultDataList) {
  if (Array.isArray(resultDataList) && resultDataList.length) {
    const paramList = resultDataList.map(item => {
      const { planUuid, insuranceList, interestSetting } = item
      const paramMap = {
        uuid: planUuid,
        insuranceId: _get(insuranceList, '[0].key'),
        bonus: { value : _get(interestSetting, 'bonus') || null },
        rate: { value : _get(interestSetting, 'rate') || null },
        bonusTake: { value : _get(interestSetting, 'bonusTake') || null },
        pensionTake: { value : _get(interestSetting, 'pensionTake') || null },
        // bonusSyncFlag: _get(interestSetting, 'bonusSyncFlag') || null,
        accRate: _get(interestSetting, 'accRate') || null,
        bonusRealRate: _get(interestSetting, 'bonusRealRate') || null,
        // bonusDataType: _get(interestSetting, 'bonusDataType') || null,
        // bonusShowSelector: _get(interestSetting, 'bonusShowSelector') || null,
        yearRate: _get(interestSetting, 'yearRate') || null,
        monthRate: _get(interestSetting, 'monthRate') || null,
        drawValue: _get(interestSetting, 'drawValue') || null,
        drawFlag: false
        // addAndTakeData: _get(interestSetting, 'addAndTakeData') || null,
        // drawData: _get(interestSetting, 'reduceBaofData') || null
      }
      return paramMap
    })
    return getComparev3InterestDetailWithTiers({ insuranceInterestParamList: paramList})
  }
  return Promise.resolve()
}